import { PortalIcon, type PortalIconProps } from './portal-icon';

/** History — clock face for the History tab. */
export function HistoryIcon(props: PortalIconProps) {
  return (
    <PortalIcon {...props}>
      <circle cx="12" cy="12" r="8.25" />
      <path d="M12 7.5V12l3.2 2" />
    </PortalIcon>
  );
}
